<template>
<div>
  <v-toolbar id="nav" color="black" clipped-right dark fixed app :scroll-threshold="0" scroll-off-screen>
    <v-toolbar-side-icon class="hidden-lg-and-up" @click="expand=!expand"></v-toolbar-side-icon>
    <v-toolbar-title>
      <router-link to="/" id="logo"><img src="@/assets/logo.png" alt="Caos logo"></router-link>
    </v-toolbar-title>
    <v-spacer v-if="!user"></v-spacer>
    <v-toolbar-items id="navItems" :class="[user ? 'flex hidden-md-and-down' : 'flex-not hidden-sm-and-down', '']">
      <v-btn class="custom-font" to="/suits" flat>Custom Suits</v-btn>
      <v-btn class="custom-font" to="/stocksuits" flat>Stock Suits</v-btn>
      <v-btn class="custom-font" to="/workwear" flat>Work Wear</v-btn>
      <v-btn class="custom-font" to="/gallery" flat>Gallery</v-btn>
      <v-btn class="custom-font" to="/about" flat>About</v-btn>
      <v-btn class="custom-font" to="/contact" flat>Contact</v-btn>
      <v-btn flat to="/cart" style="background-image: linear-gradient(to right,#f72f07 0%,#fc5e03 51%,#f72f07 100%);" class="orange white-text custom-font caos-font">Checkout({{cart}})</v-btn>
       <template v-if="user">
         <v-spacer></v-spacer>
        <v-btn v-for="item in admins" :key="item.route" class="white--text custom-font" flat :to="item.route">{{item.title}}</v-btn>
        <v-btn class="red white--text" @click="logout" flat>Logout</v-btn>
      </template>
    </v-toolbar-items>
  </v-toolbar>


  <v-navigation-drawer v-model="expand" fixed dark temporary>
    <v-container fill-height>
      <v-layout column fill-height>
        <v-flex xs12>
          <v-list>
            <v-list-tile v-for="item in items" :key="item.title" :to="item.route" class="white--text" active-class="red--text">
              <v-list-tile-content>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-btn to="/cart" color="orange" class="white-text">Checkout({{cart}})</v-btn>
          </v-list>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex v-if="user">
          <v-list>
            <v-list-tile v-for="item in admins" :key="item.title" :to="item.route" class="white--text" active-class="red--text">
              <v-list-tile-content>
                <v-list-tile-title v-text="item.title"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-btn class="red white--text" @click="logout" flat>Logout</v-btn>
          </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</div>
</template>

<script>
import * as firebase from "../firebase.js";
export default {
  data() {
    return {
      expand: false,
      items: [{
          title: 'Home',
          route: "/"
        },
        {
          title: 'Custom Suits',
          route: "/suits"
        },
        {
          title: 'Stock Suits',
          route: "/stocksuits"
        },
        {
          title: 'Work Wear',
          route: "/workwear"
        },
        {
          title: 'Gallery',
          route: "/gallery"
        },
        {
          title: 'About',
          route: "/about"
        },
        {
          title: 'Contact',
          route: "/contact"
        },
        // {
        //   title: 'Comments',
        //   route: "/comments"
        // }
      ],
       admins:[{
          title: 'Orders',
          route: "/orders"
        },
        {
          title: 'Admin',
          route: "/admin"
        },
        {
          title: 'Messages',
          route: "/messages"
        }]
    }
  },
  methods:{
    logout() {
      firebase.auth.signOut().then(() => {
        this.$store.dispatch({
          type: 'removeAdmin'
          })
        this.$router.replace('login');
      })
    },
  },
  computed: {
    cart(){
      return this.$store.getters.itemsInCart.length;
    },
    user(){
      return this.$store.getters.user;
    }
  }
}
</script>

<style scoped>
.flex{
  flex-basis:50%;
}
.flex-not{
  flex:0;
}
img {
  max-width: 180px;
  vertical-align: top;
}
.under{
  text-decoration: none;
}
.router-link-exact-active{
  opacity: .8;
}
#logo{
  opacity: 1;
}
.custom-font {
  font-family: poppins;
}


</style>
